const exportedObject = {
  getPrecertificacionData: {},
  getPrecertificacionLoading: false,
  getPrecertificacionError: null,

  consultarPrecertificacionesData: {},
  consultarPrecertificacionesLoading: false,
  consultarPrecertificacionesError: null,

  confirmarPrecertificacionData: {},
  confirmarPrecertificacionLoading: false,
  confirmarPrecertificacionError: null,

  cancelarPrecertificacionData: {},
  cancelarPrecertificacionLoading: false,
  cancelarPrecertificacionError: null,

  tiposSolicitudesPrecertificacionData: undefined,
  tiposSolicitudesPrecertificacionLoading: false,
  tiposSolicitudesPrecertificacionError: null,

  crearPrecertificacionData: undefined,
  crearPrecertificacionLoading: false,
  crearPrecertificacionError: null,

  consultarUnaPrecertificacionData: {},
  consultarUnaPrecertificacionLoading: false,
  consultarUnaPrecertificacionError: null,

  modificarPrecertificacionData: undefined,
  modificarPrecertificacionLoading: false,
  modificarPrecertificacionError: null,

  descargarVoucherPrecertificacionData: undefined,
  descargarVoucherPrecertificacionLoading: false,
  descargarVoucherPrecertificacionError: null
};

export default exportedObject;
